import { atom } from "recoil";
import { ThoughtRecordItemType } from "api/homeApi";

export const homeThoughtRecordListAtom = atom<ThoughtRecordItemType[]>({
  key: "homeThoughtRecordListAtom",
  default: [],
});
